<!DOCTYPE html>
<html lang="en">
  <head>
    <!-- Required meta tags -->
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>NorsupOne</title>
  </head>
  <body>
    <div class="container-fluid">
      <div class="row gx-0">
        <div class="col-lg-12">
          <div class="side-menu">
            <app-side-bar></app-side-bar>
          </div>
          <div class="right-side">
            <div class="pt-3">
              <div class="glass-bg w-100 profile-card-block">
                <div class="profile-card px-3 text-center">
                  <div class="user-avatar pb-3 edit-avatar">
                    <img [src]="profileImage" />
                  </div>

                  <form
                  [formGroup]="changePasswordForm"
                  (ngSubmit)="onSubmit()"
                    class="px-2 profile-edit">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1"
                        class="form-label">Current password</label>
                      <input type="text" class="form-control"
                        id="exampleFormControlInput1"
                        class="form-control"
                        placeholder="Current password"
                        formControlName="currentPassword"
                        name="editedFirstName">
                    </div>

                    <div class="mb-3">
                      <label for="exampleFormControlInput1"
                        class="form-label">New password</label>
                      <input type="text" class="form-control"
                        id="exampleFormControlInput1"
                        class="form-control"
                        placeholder="New password"
                        formControlName="newPassword"
                        name="editedLastName">
                    </div>
                    <div class="mb-3">
                      <label for="exampleFormControlInput1"
                        class="form-label">Re-type password</label>
                      <input type="text" class="form-control"
                        id="exampleFormControlInput1"
                        class="form-control"
                        placeholder="Re-type password"
                        formControlName="reTypePassword"
                        name="editedLastName">
                    </div>
                    <span class="alert-message"
                      *ngIf="errorString">{{errorString}}</span>
                      <span *ngIf="currentPassword?.errors?.['minlength'] && !errorString" class="alert-message">
                        {{passwordLengthMessage}}
                      </span>
                      <span *ngIf="newPassword?.errors?.['minlength'] && !errorString" class="alert-message">
                        {{passwordLengthMessage}}
                      </span>
                      <span *ngIf="reTypePassword?.errors?.['minlength'] && !errorString" class="alert-message">
                        {{passwordLengthMessage}}
                      </span>
                    <div class="d-grid gap-2 pt-2">
                      <button class="btn btn-primary"
                        type="button" (click)="onSubmit()">CHANGE</button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </body>
</html>
